module.exports = __webpack_public_path__ + "ed0e1091a188b0c14c20a47d943cd29c.svg";